var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnOffWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5555 2.14682C18.0555 3.93253 19.6825 6.85317 19.6825 10.1587C19.6825 15.5873 15.2857 19.9881 9.86111 20C4.44445 20.0119 0.00794374 15.5952 7.2427e-06 10.1746C-0.00396101 6.86904 1.62302 3.94047 4.11905 2.15079C4.58334 1.82143 5.23016 1.96032 5.50794 2.45635L6.13492 3.57142C6.36905 3.98809 6.25794 4.51587 5.87302 4.80158C4.22619 6.0238 3.17461 7.96031 3.17461 10.1547C3.17064 13.8174 6.13095 16.8254 9.84127 16.8254C13.4762 16.8254 16.5317 13.8809 16.5079 10.1151C16.496 8.05951 15.5278 6.07539 13.8055 4.79761C13.4206 4.5119 13.3135 3.98412 13.5476 3.57142L14.1746 2.45635C14.4524 1.96428 15.0952 1.81746 15.5555 2.14682ZM11.4286 10.4762V0.95238C11.4286 0.424603 11.004 0 10.4762 0H9.20635C8.67857 0 8.25397 0.424603 8.25397 0.95238V10.4762C8.25397 11.004 8.67857 11.4286 9.20635 11.4286H10.4762C11.004 11.4286 11.4286 11.004 11.4286 10.4762Z",
    fill: "#F4F6F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnOffWhite);
export default __webpack_public_path__ + "static/media/on-offWhite.92d47cc6569d8c7623630340771a4d3d.svg";
export { ForwardRef as ReactComponent };